<script>
  import { Router, Route } from "svelte-routing";
  import data from "./routes/index.js";
  import { navigate } from 'svelte-routing';
  
  import Layout from "./routes/Layout.svelte";
  import Login from "./pages/Authentication/Login.svelte";

  import { userStore } from "./helpers/store";

  export let url = "";

  import { addMessages, init } from "svelte-i18n";

  // import en from "../public/lang/en.json";
  import kr from "../public/lang/kr.json";

  // addMessages("en", en);
  addMessages("kr", kr);

  init({
    initialLocale: "kr",
  });

  // console.log(userStore);

  // if (userStore.loggedIn) {
  //   isAuthenticated = true;
  // }

</script>

<Router {url}>
  {#each data.publicRoutes as route}
    <Route path={route.path} let:params>
      <Layout>
        <svelte:component this={route.component} />
      </Layout>
    </Route>
  {/each}

  {#each data.onePageRoutes as route}
    <Route path={route.path}>
      <svelte:component this={route.component} />
    </Route>
  {/each}

  {#each data.authProtectedRoutes as route}
    {#if $userStore.loggedIn}
    <Route path={route.path} let:params>
      <Layout>
        <svelte:component this={route.component} />
      </Layout>
    </Route>
    {:else}
    <Route path={route.path} let:params>
      <Layout>
        <svelte:component this={Login} />
      </Layout>
    </Route>
    {/if}
  {/each}
</Router>
